import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { nl } from './nl';
import { fr } from './fr';
import { getQSVar } from '../utils';

export const initI18n = () => {
    const lng = getQSVar('lng') || 'nl';

    i18n.use(initReactI18next).init({
        lng,
        resources: {
            nl: {
                translation: nl,
            },
            fr: {
                translation: fr,
            },
        },
        fallbackLng: 'nl',
        debug: process.env.NODE_ENV === 'development',
    });
};
